import React, { FunctionComponent, useRef } from "react"
import Grid from "../../components/Grid/Grid"
import LinkItem from "../../components/Grid/LinkItem"
import Loader from "../../components/Loader/Loader"
import Pagination from "../../components/Pagination/Pagination"
import Seo from "../../components/Seo/Seo"
import { iExhibition, iExhibitionQuery } from "../../definitions/Exhibition"
import { isAdmin } from "../../helpers/isAdmin"
import { useData } from "../../hooks/useData"
import s from "./Exhibitions.less"
import ExhibitionFilters from "./Filters"
import Item from "./Item"

const Exhibitions: FunctionComponent = () => {
  const defaultQueryRef = useRef<iExhibitionQuery>({
    public: isAdmin() ? true : false,
  })
  const { total, data, loading, setQuery, query } = useData<
    iExhibitionQuery,
    iExhibition
  >({
    link: "/v2/exhibitions",
    defaultQuery: defaultQueryRef.current,
    shouldPingForData: true,
    shouldPushQuery: true,
  })

  return (
    <>
      <Seo title={"Exhibitions"} />
      <div className="content">
        <div className="content-header">
          <h1>Exhibitions ({total})</h1>
          <ExhibitionFilters setQuery={setQuery} query={query} />
        </div>
        <div className={`grid-wrap ${s.gridWrap}`}>
          {loading ? (
            <Loader />
          ) : data.length ? (
            <Grid>
              {data.map((exhibition) => (
                <LinkItem
                  key={exhibition._id}
                  url={"/exhibitions/" + exhibition.url}
                >
                  <Item key={exhibition._id} {...exhibition} />
                </LinkItem>
              ))}
            </Grid>
          ) : (
            <div className="no-data">No matching results.</div>
          )}
        </div>
        <Pagination total={total} limit={50} setQuery={setQuery} />
      </div>
    </>
  )
}

export default Exhibitions
